export default "__VITE_ASSET__CXKJcmu7__"